import React from 'react'
import api, { LoginInput } from 'api'
import { message } from 'antd'
import {  setUserPermission } from 'services/permission'
import {appModule} from 'services/module'

let localUser = { isLogin: false } as IUser
let userStr = localStorage.getItem('currentUser')
if (userStr) {
	localUser = JSON.parse(userStr)
}

export interface IUserContext {
	user: IUser
	login: (loginModel: LoginInput) =>Promise<IUser>
	loginOut: () => void
	setPermissions: (systemCode: string) => Promise<AppPermissions>
	setModelingSystemCode: (systemCode: string) => void
}

const UserContext = React.createContext<IUserContext>({
	user: localUser,
} as IUserContext)

class UserProvider extends React.Component<React.Props<any>> {
	public static getCurrentUser() {
		return UserProvider.user
	}

	static login = async (loginInput: LoginInput) => {
		let loginResult = await api.public.account.login(loginInput)
		
		if (loginResult.result) {
			let auth = loginResult.data
			let user = { ...auth, isLogin: true, permissions: auth.permissions }
			UserProvider.setCurrentUser(user)
			UserProvider.instance.forceUpdate()
			return user
		} else {
			message.error(loginResult.msg)
			return { isLogin: false }
		}
	}

	static setPermissions = async (systemCode: string) => {
		if (UserProvider.user.isLogin) {
			console.log('systemCode:',systemCode)
			let permissions = await api.security.getPermissions({ systemCode })
			let user = { ...UserProvider.user, permissions }
			UserProvider.setCurrentUser(user)
			UserProvider.instance.forceUpdate()
			return permissions
		} else {
			UserProvider.setCurrentUser({ isLogin: false, permissions: {} })
			UserProvider.instance.forceUpdate()
			return { actionList: [],systemList:[] }
		}
	}

	static setModelingSystemCode = async (systemCode: string) => {
		if (UserProvider.user.isLogin) {
			let permissions = {...UserProvider.user.permissions}
			let user = { ...UserProvider.user, permissions }
			appModule.setCurrentModelingSystem(systemCode);
			UserProvider.setCurrentUser(user)
			UserProvider.instance.forceUpdate()
			return permissions
		} else {
			UserProvider.setCurrentUser({ isLogin: false, permissions: {} })
			UserProvider.instance.forceUpdate()
			return { currSystemCode: '', currModelingSystemCode: '' }
		}
	}

	static loginOut = () => {
		UserProvider.setCurrentUser({ isLogin: false, permissions: {} })
		UserProvider.instance.forceUpdate()
	}
	private static user = localUser

	private static setCurrentUser = (user: IUser) => {
		UserProvider.user = user
		setUserPermission(user.permissions)
		localStorage.setItem('currentUser', JSON.stringify(user))
	}

	static instance: UserProvider
	constructor(props: any) {
		super(props)
		UserProvider.instance = this
		localUser.isLogin && setUserPermission(localUser.permissions)
	}

	async componentDidMount() {
		if (UserProvider.user.isLogin) {
			let systemCode = appModule.getSysCodeByPath(window.location.pathname);
			let permissions = await api.security.getPermissions({ systemCode })
			let user = { ...UserProvider.user, permissions }
			UserProvider.setCurrentUser(user)
			UserProvider.instance.forceUpdate()
		}
	}

	render() {
		let { children } = this.props
		return (
			<UserContext.Provider
				value={{
					login: UserProvider.login,
					loginOut: UserProvider.loginOut,
					user: UserProvider.user,
					setPermissions: UserProvider.setPermissions,
					setModelingSystemCode: UserProvider.setModelingSystemCode,
				}}
			>
				{children}
			</UserContext.Provider>
		)
	}
}
export default UserContext

export { UserProvider }



// WEBPACK FOOTER //
// ./src/modules/User/UserContext.tsx